<main class="fld-col ai-ctr jc-ctr vh-p100">
  <myqq-error
    [title]="state?.title"
    [description]="state?.description"
    [error]="state?.error"
    class="mwtr-p10"
  >
    <button
      myqq-button
      aria-label="Refresh myQQ"
      class="raised as-ctr"
      color="primary"
      (click)="handleRefresh()"
      (keyup.enter)="handleRefresh()"
      (keydown.enter)="$event.preventDefault()"
    >
      Refresh myQQ
    </button>
  </myqq-error>
</main>
